<template>
    <div class="container max-w-screen-xl p-4 mx-auto">

        <slot></slot>

    </div>
</template>
<script>
export default {
    props: ['classes']
};
</script>


<style lang="scss" scoped>

</style>
